/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useMemo } from 'react';
import { SideBarControlled, useTheme } from '@ihsm/ui-shared';
import { useActions, useAppSelector } from 'state/store';
import { PRODUCT_PREFIX } from './constants';
import { useNavBarItems } from './hooks';
import './SideBarMenu.scss';

export const SideBarMenu: React.FC = (): JSX.Element => {
  const navigationItems = useNavBarItems();
  const { contexts } = useAppSelector((state) => state.contextsState);
  const { theme, setTheme } = useTheme();

  const { setSideBarCollapsed } = useActions();
  const { isSideBarCollapsed } = useAppSelector((state) => state.uiState);

  const selectedContext = useMemo(() => {
    if (contexts && contexts.length > 0) {
      return contexts[0];
    }
    return '';
  }, [contexts]);

  // eslint-disable-next-line consistent-return
  const toggleTheme = () => {
    if (theme === 'dark') {
      return setTheme('light');
    }
    setTheme('dark');
  };

  return (
    <div>
      <SideBarControlled
        navigationItems={navigationItems}
        productPrefix={PRODUCT_PREFIX}
        selectedTheme={theme === 'dark' ? 'light' : 'dark'}
        onThemeChange={toggleTheme}
        collapsed={isSideBarCollapsed}
        onCollapsedChanged={(collapsed: boolean) =>
          setSideBarCollapsed(collapsed)
        }
        selectedContext={selectedContext}
      />
    </div>
  );
};
